"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SiteFormatChange_1 = require("../model/SiteFormatChange");

var SiteFormatChangeConverter_1 = require("./SiteFormatChangeConverter");
/**
 * @author Radim Krkoška
 */


var SiteFormatChangeConverterImpl =
/*#__PURE__*/
function (_SiteFormatChangeConv) {
  _inherits(SiteFormatChangeConverterImpl, _SiteFormatChangeConv);

  function SiteFormatChangeConverterImpl() {
    _classCallCheck(this, SiteFormatChangeConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SiteFormatChangeConverterImpl).apply(this, arguments));
  }

  _createClass(SiteFormatChangeConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new SiteFormatChange_1.SiteFormatChange(SiteFormatChange_1.SiteFormatChange.schema.id.valueOf(conversions.documentToClassId(source)), SiteFormatChange_1.SiteFormatChange.schema.siteId.valueOf(conversions.toClassReferenceId(source.siteId)), SiteFormatChange_1.SiteFormatChange.schema.oldFormatId.valueOf(conversions.toClassReferenceId(source.oldFormatId)), SiteFormatChange_1.SiteFormatChange.schema.newFormatId.valueOf(conversions.toClassReferenceId(source.newFormatId)), SiteFormatChange_1.SiteFormatChange.schema.validFrom.valueOfField(source), source.optEngineUpdateTime ? SiteFormatChange_1.SiteFormatChange.schema.optEngineUpdateTime.valueOfField(source) : null);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        siteId: conversions.toDocumentReferenceId(source.siteId),
        oldFormatId: conversions.toDocumentReferenceId(source.oldFormatId),
        newFormatId: conversions.toDocumentReferenceId(source.newFormatId),
        validFrom: conversions.fromDate(source.validFrom),
        optEngineUpdateTime: source.optEngineUpdateTime ? conversions.fromDate(source.optEngineUpdateTime) : null
      });
      return result;
    }
  }]);

  return SiteFormatChangeConverterImpl;
}(SiteFormatChangeConverter_1.SiteFormatChangeConverter);

exports.SiteFormatChangeConverterImpl = SiteFormatChangeConverterImpl;